import {useState, useEffect, HTMLAttributes} from 'react'
import { fetchAPI } from '../utils/FetchApi';
import {FetchMethods} from "../interface/Enums/methods.enum"
import { useDispatch, useSelector } from 'react-redux';
import { setError } from "../store/reducers/errorReducer";
import { H2 } from './StyledComponents';
import useAuthLevel from '../custom-hooks/get-auth-level';
import { Roles } from '../interface/Enums/Roles.enum';

interface CountryInterface {
    name: string;
    createdAt: Date;
    updatedAt: Date;
    _id: string;
  className?: HTMLAttributes<HTMLElement>["className"];
  }
const CountryFilter = ({returnedCountry, className, showHeading = true}:{returnedCountry:Function, className?: HTMLAttributes<HTMLElement>["className"], showHeading?:boolean}) => {

const dispatch = useDispatch()

const [countries, setCountries] = useState<CountryInterface[]>([]);
const [selectedCountry, setSelectedCountry] = useState<string|null>(localStorage.getItem("selected-country")||null);
const authLevel = useAuthLevel();
const userCountry = useSelector((state: any) => state.auth.user.country)
//Loads countries
useEffect(() => {
  if (authLevel === Roles.OmniAdmin) {
(async () => {
      try {
        const countries: CountryInterface[] = await fetchAPI(
          "/admincmds/get-all-countries",
          FetchMethods.GET
        );
        countries.sort((a, b) => (a.name > b.name ? 1 : -1));
        setCountries(countries);

        const getCountryFromLocal:string|null = localStorage.getItem("selected-country");
        if(getCountryFromLocal){
          setSelectedCountry(getCountryFromLocal)
          returnedCountry(getCountryFromLocal)
        }
      } catch (error: any) {
        dispatch(setError(error.message.toString()));
      }
    })();

  }else if (authLevel === Roles.SalesForceManager) {
    setSelectedCountry(userCountry);
    returnedCountry(userCountry);
  }
    


  }, [dispatch, selectedCountry, returnedCountry, userCountry, authLevel]);

  


  return (
    <div className={`${className}`}>
      {
        showHeading && (
          <H2 className="h3">{authLevel === Roles.OmniAdmin ? "Select country" : "Your country"}</H2>
        )
      }
      {

        authLevel === Roles.SalesForceManager ? (
          <div className="alert alert-info">
            {userCountry}
          </div>
        ) : null
      }
      {
        authLevel === Roles.OmniAdmin ? ( <select
          className="form-control dai-input shadow-sm border-sky-200"
          value={selectedCountry||-1}
          onChange={({ target }) => {
            localStorage.setItem("selected-country", target.value)
            setSelectedCountry(target.value);
          }}
        >
          {
            authLevel === Roles.OmniAdmin  && <option className="form-control" value={-1}>
            Select country
          </option>
          }
          {countries.map((c: CountryInterface, i: number) => (
            <option key={i} value={c.name}>
              {c.name}
            </option>
          ))}
        </select>) : null
      }
       
    </div>
  )
}

export default CountryFilter